<template>
    <div class="profile text-center">
        <picture-upload @input="imageDataUser">
            <img 
            class="rounded-circle img-fluid profile-thumb mb-3" 
            role="button"
            :src="avatar" 
            :alt="$t('table.profile_picture')" 
            :title="$t('table.upload_profile_picture')" 
        >
        </picture-upload>
        <h4 class="text-gray">
            {{ this.$store.state.user.user.firstname + ' ' + this.$store.state.user.user.lastname }}
        </h4>
    </div>
</template>

<script>
import Vue from 'vue';
import http from '@/libs/http';
import PictureUpload from '@/components/global/miscellaneous/PictureUpload.vue';
import miniToastr from 'mini-toastr';

export default {
    name: 'profile_header',
    components: {
        PictureUpload,
        miniToastr
    },
    data() {
        return {
            userImage: null
        }
    },
    computed: {
        avatar: {
            get: function () {
                let avatar = this.$store.getters.getUserAvatar;
                return avatar;
            }
        }
    },
    watch: {
        avatar: {
            immediate: true,
            deep: true,
            handler(newVal, oldVal) {
            }
        }
    },
    methods: {
        successMsg(msg) {
            miniToastr.success(msg, Vue.i18n.translate('messages.success'), 5000);
        },
        errorMsg(msg) {
            miniToastr.error(msg, Vue.i18n.translate('messages.error'), 5000);
        },
        imageDataUser (image) {
            this.userImage = image.imageFile
            var formData = new FormData();
            formData.append('image', this.userImage);

            let data = http.route('user/change_profile_picture/' + this.$store.state.user.user.id).post(
                formData,
                    {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
            ).then(res => {
                if (res.isError) {
                    Object.keys(response.errorMessage).forEach(key => {
                        this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                    });
                } else {
                    this.$store.dispatch('getUser');
                    this.successMsg(Vue.i18n.translate('messages.profile_avatar'));
                }
            });
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/pages/users/profile/profile_header.vue